/**
 * application-details.component.ts
 * ---------------------------------
 * Page 1 (Existing Assessment flow) — Update Existing Assessment : Application Details.
 *
 * Current state : COMING SOON notice page — Module 5 implementation pending.
 *
 * Route guard   : stepGuard('application-details') — requires flow mode = 'existing'.
 */

import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-application-details',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './application-details.component.html',
  styleUrl: './application-details.component.scss',
})
export class ApplicationDetailsComponent {
  // TODO (Module 5): Implement CARR fetch + application details update logic
}
